module.exports = __webpack_public_path__ + "static/media/intropart2.f91b0d06.png";